import { nip19 } from 'nostr-tools';
import { useParams, Navigate } from 'react-router-dom';
import ProfilePage from './ProfilePage';
import VideoPage from './VideoPage';
import NotFound from './NotFound';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type, data } = decoded;

  switch (type) {
    case 'npub': {
      // Render profile page with this pubkey
      const pubkey = data as string;
      return <ProfilePageWithPubkey pubkey={pubkey} />;
    }
    case 'nprofile': {
      const { pubkey } = data as { pubkey: string };
      return <ProfilePageWithPubkey pubkey={pubkey} />;
    }
    case 'note': {
      const eventId = data as string;
      return <VideoPageWithId id={eventId} />;
    }
    case 'nevent': {
      const { id } = data as { id: string };
      return <VideoPageWithId id={id} />;
    }
    case 'naddr': {
      // For addressable video events, redirect to video page by event id won't work directly.
      // Show a generic page — would need relay query by naddr coords.
      return <NotFound />;
    }
    default:
      return <NotFound />;
  }
}

// Small wrappers to inject params via context override
function ProfilePageWithPubkey({ pubkey }: { pubkey: string }) {
  // Redirect to a URL that the ProfilePage route can pick up
  return <Navigate to={`/profile/${pubkey}`} replace />;
}

function VideoPageWithId({ id }: { id: string }) {
  return <Navigate to={`/video/${id}`} replace />;
}
